import type { ReactElement } from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { MangoProvider } from '@humanforce/mango-ui-react';
import { MainLayout } from './components/layout/MainLayout';
import { itemPath, navSections } from './navigation/navConfig';
import { pageRegistry } from './pages';
import { HomePage } from './pages/HomePage';

// Build the route table from the data-driven navigation config so adding or
// reshaping navigation never requires hand-editing routes here.
const buildItemRoutes = (): ReactElement[] => {
  const routes: ReactElement[] = [];
  for (const section of navSections)
    for (const item of section.items ?? []) {
      const Page = pageRegistry[itemPath(section, item)];
      if (!Page) continue;
      const rel = `${section.slug}/${item.slug}`;
      if (item.subItems?.length) {
        // Item route redirects to the first tab; each sub-item tab is URL-addressable.
        routes.push(<Route key={rel} path={rel} element={<Navigate to={item.subItems[0].slug} replace />} />);
        routes.push(<Route key={`${rel}/:tab`} path={`${rel}/:tab`} element={<Page />} />);
      } else {
        routes.push(<Route key={rel} path={rel} element={<Page />} />);
      }
    }
  return routes;
};

export const App = () => (
  <MangoProvider>
    <MainLayout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        {buildItemRoutes()}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </MainLayout>
  </MangoProvider>
);
